module.exports = __webpack_public_path__ + "static/media/delete.9e3f441c.svg";